var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center mr-4"},[(_vm.operatorQueue)?_c('small',{staticClass:"ml-2"},[_vm._v("Na Fila?")]):_vm._e(),(_vm.operatorQueue)?_c('vs-switch',{staticClass:"ml-2",staticStyle:{"display":"inline-flex"},attrs:{"color":"success","checked":_vm.inQueue},on:{"click":_vm.confirmActivateRecord}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }